import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import classNames from 'classnames';
const CLASS_NAME = 'asc-btn';
const Button = _ref => {
  let {
    buttonRef,
    className,
    clickHandler,
    customAttrs,
    disabled = false,
    icon,
    iconAlignment,
    loadingText = 'processing',
    qaId = '',
    showLoading = false,
    text,
    type = 'button'
  } = _ref;
  const [isPendingResolve, setIsPendingResolve] = useState(false);
  const handleClick = event => {
    const handler = clickHandler && clickHandler(event);
    if (handler && handler instanceof Promise) {
      setIsPendingResolve(true);
      handler.then(() => {
        setIsPendingResolve(false);
      }).catch(() => {
        setIsPendingResolve(false);
      });
    }
  };
  const alignIconLeft = iconAlignment === 'left';
  const content = icon ? /*#__PURE__*/React.createElement("span", {
    className: "asc-btn--content"
  }, iconAlignment === 'left' && icon, text, iconAlignment === 'right' && icon) : text;
  const classnames = classNames(CLASS_NAME, {
    [className]: Boolean(className),
    'is-loading': showLoading || isPendingResolve,
    'asc-btn--icon-right': icon && !alignIconLeft,
    'asc-btn--icon-left': icon && alignIconLeft
  });
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    className: classnames,
    "data-qa": qaId,
    disabled: disabled === true || isPendingResolve,
    onClick: handleClick,
    ref: buttonRef,
    "aria-label": showLoading || isPendingResolve ? loadingText : undefined
  }, customAttrs), showLoading || isPendingResolve ? /*#__PURE__*/React.createElement("span", {
    className: "asc-btn--loading-indicator"
  }, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 40 8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "4",
    cy: "4",
    rx: "4",
    ry: "4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "1;0.9;0.8;0.7;0.6;0.5;0.4;0.4;0.4",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.625;0.75;0.875;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: "20",
    cy: "4",
    rx: "4",
    ry: "4",
    fillOpacity: "0.4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.4;1;0.9;0.8;0.7;0.6;0.5;0.4;0.4",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.625;0.75;0.875;1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: "36",
    cy: "4",
    rx: "4",
    ry: "4",
    fillOpacity: "0.4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.4;0.4;1;0.9;0.8;0.7;0.6;0.5;0.4",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.625;0.75;0.875;1"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "asc-btn--loading-indicator--hidden-content"
  }, content)) : content);
};
export default Button;